import { Component, Input, Renderer2, OnInit, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, query, animateChild, AnimationEvent } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../base-component/base.component';

// TODO:
// - Create a standard interface to be emitted for events
// - Get info from UX on the widths of the slideout at various breakpoints

@Component({
    selector: 'amobee-slideout',
    exportAs: 'slideout',
    templateUrl: './amobee-slideout.component.html',
    styleUrls: [ './amobee-slideout.component.scss' ],
    animations: [
        trigger(
            'animateChild', [
                transition(':enter, :leave', [
                    query('@*', animateChild())
                ])
            ]
        ),
        trigger(
            'fadeInOut', [
                transition(':enter', [
                    style({opacity: 0}),
                    animate('250ms', style({opacity: 1}))
                ]),
                transition(':leave', [
                    style({opacity: 1}),
                    animate('250ms', style({opacity: 0}))
                ])
            ]
        ),
        trigger(
            'enterAnimation', [
                transition(':enter', [
                    style({transform: 'translateX(100%)', opacity: 0}),
                    animate('250ms 0ms cubic-bezier(0.77, 0, 0.175, 1)', style({transform: 'translateX(0)', opacity: 1}))
                ]),
                transition(':leave', [
                    style({transform: 'translateX(0)', opacity: 1}),
                    animate('250ms 0ms cubic-bezier(0.77, 0, 0.175, 1)', style({transform: 'translateX(100%)', opacity: 0}))
                ])
            ]
        )
    ]
})

export class AmobeeSlideoutComponent extends BaseComponent implements OnInit {
    @Input() public slideoutTitle: string;
    @Input() public padded: boolean = true;
    @Input() public backdropDismisses: boolean = true;
    @Input() public width: number = 40;

    @Output() public openAnimationComplete: EventEmitter<void> = new EventEmitter<void>();
    @Output() public closed: EventEmitter<any> = new EventEmitter<any>();

    public isOpen: boolean = this.isSlideoutRouted;

    constructor(public renderer: Renderer2, public router: Router, public route: ActivatedRoute) {
        super();
    }

    public ngOnInit(): void {
        if (this.isOpen) {
            this.onShowSlideout();
        }
    }

    public open(): void {
        this.onShowSlideout();
    }

    public close($event: any): void {
        this.onHideSlideout($event);
    }

    public onSlideComplete($event: AnimationEvent): void {
        // Once the slideout finished opening, fire the event
        if ($event.toState === null) {
            this.openAnimationComplete.next();
        }

        // Once the slideout finishes closing, if it's routed, update the route.
        if ($event.toState === 'void') {
            if (this.isSlideoutRouted) {
                this.router.navigate([{ outlets: { slideout: null } }]);
            }
        }
    }

    private get isSlideoutRouted(): boolean {
        return this.route.snapshot.outlet === 'slideout';
    }

    public onBackdropClick($event: any): void {
        if (this.backdropDismisses && $event.target === $event.currentTarget) {
            this.onHideSlideout($event);
        }
    }

    private onShowSlideout(): void {
        this.renderer.setStyle(document.body, 'overflow', 'hidden');
        this.isOpen = true;
    }

    private onHideSlideout($event: any): void {
        this.renderer.removeStyle(document.body, 'overflow');
        this.isOpen = false;
        this.closed.next($event);
    }

}
